module.exports = __webpack_public_path__ + "static/img/ent-75.3ebc7b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-75.jpg
// module id = hQa6
// module chunks = 51